import React from "react";
import { useSelector } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";

const ListMerchantTableBody = (props) => {
  const restaurantType = useSelector((state) => {
    return !isEmpty(state.category) ? state?.category?.restaurant_type : "";
  });
  const primaryRestaurantTypeAction = (Id) => {
    let primaryRestaurantType =
      restaurantType &&
      restaurantType.filter((item, index) => {
        return item._id === Id;
      });
    return primaryRestaurantType;
  };

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr style={{ display: "contents" }}>
        {props.viewAccess !== "ViewDashboard" ? (
          <td
            style={{ paddingLeft: 28, width: "10%", verticalAlign: "middle" }}
          >
            <input
              type="checkbox"
              id="restaurants"
              name="restaurants"
              // selected={props.selectedCheck}
              onChange={props.onClickCheckBoxAction}
              value={props.selectedCheck}
              checked={props.selectedCheck ? true : false}
            />
          </td>
        ) : null}
        <td
          style={{
            width: props.viewAccess !== "ViewDashboard" ? "15%" : "20%",
            verticalAlign: "middle",
            paddingLeft: props.viewAccess !== "ViewDashboard" ? "" : 28,
          }}
        >
          <div
            className={`f11-400 ${
              props.viewAccess !== "ViewDashboard" ? "" : "text-break"
            }`}
            style={{ fontWeight: 400 }}
          >
            #{props?.userType?._id}
          </div>
        </td>
        <td style={{ width: "20%", verticalAlign: "middle" }}>
          <div className="f11-400" style={{ fontWeight: 400 }}>
            {props?.userType?.restaurant_name}
          </div>
        </td>
        <td
          style={{
            width: props.viewAccess !== "ViewDashboard" ? "25%" : "24%",
            verticalAlign: "middle",
          }}
        >
          {props?.userType?.point_of_contact.map((data, index) => {
            return data?.defaultChecked ? (
              <React.Fragment>
                <div className="f11-400" style={{ fontWeight: 400 }}>
                  {data?.firstName + " " + data?.lastName}
                </div>
                <div className="f11-400" style={{ fontWeight: 400 }}>
                  {data?.enquiry_emails?.[0]}
                </div>
                <div className="f11-400" style={{ fontWeight: 400 }}>
                  {data?.phone_numbers?.[0]?.country_code +
                    " " +
                    data?.phone_numbers?.[0]?.mobile_no}
                </div>
              </React.Fragment>
            ) : null;
          })}
        </td>
        <td style={{ width: "10%", verticalAlign: "middle" }}>
          <div className="f11-400" style={{ fontWeight: 400 }}>
            {props?.userType?.city}
          </div>
        </td>
        <td style={{ width: "10%", verticalAlign: "middle" }}>
          <div className="f11-400" style={{ fontWeight: 400 }}>
            {props?.userType?.area}
          </div>
          <div className="f11-400" style={{ fontWeight: 400 }}>
            {props?.userType?.pinCode}
          </div>
        </td>
        <td
          style={{
            width: props.viewAccess !== "ViewDashboard" ? "10%" : "16%",
            verticalAlign: "middle",
          }}
        >
          <div className="f11-400" style={{ fontWeight: 400 }}>
            {props.viewAccess !== "ViewDashboard"
              ? props?.userType?.primary_restaurant_type?.title
              : primaryRestaurantTypeAction(
                  props?.userType?.primary_restaurant_type
                ).map((data, index) => {
                  return data?.title;
                })}
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default ListMerchantTableBody;
